// Execute immediately to initialize currency selection
(function() {
  // Function to get currency from URL
  function getCurrencyFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const currencyParam = urlParams.get('currency');
    
    // Check if the currency parameter exists and is a valid 3-character code
    if (currencyParam && /^[A-Z]{3}$/.test(currencyParam)) {
      return currencyParam;
    }
    return null;
  }
  
  // Function to get currency from localStorage with expiration check
  function getStoredCurrency() {
    const currencyData = localStorage.getItem('userCurrencyData');
    if (!currencyData) return null;
    
    try {
      const parsedData = JSON.parse(currencyData);
      const currentTime = new Date().getTime();
      const storedTime = parsedData.timestamp;
      const currency = parsedData.currency;
      
      // Check if stored currency is less than 24 hours old
      // 24 hours = 24 * 60 * 60 * 1000 = 86400000 milliseconds
      if (currentTime - storedTime < 86400000) {
        return currency;
      } else {
        // Currency data expired, remove it
        localStorage.removeItem('userCurrencyData');
        return null;
      }
    } catch (e) {
      // Invalid data format, remove it
      localStorage.removeItem('userCurrencyData');
      return null;
    }
  }
  
  // Store currency with timestamp
  function storeCurrency(currency) {
    const currencyData = {
      currency: currency,
      timestamp: new Date().getTime()
    };
    localStorage.setItem('userCurrencyData', JSON.stringify(currencyData));
  }
  
  // Check URL first, then localStorage
  const urlCurrency = getCurrencyFromUrl();
  const storedCurrency = getStoredCurrency();
  
  // If currency in URL, store it for future page visits
  if (urlCurrency) {
    storeCurrency(urlCurrency);
    window.selectedCurrency = urlCurrency;
  } 
  // Otherwise use previously stored currency if available
  else if (storedCurrency) {
    window.selectedCurrency = storedCurrency;
  }
})();

// Main functionality still executes on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  // Get the exchange rates JSON and round prices setting
  const exchangeRatesElement = document.querySelector('.ww_currency_exchange .exchange_rates_json_string');
  const roundPricesElement = document.querySelector('.ww_currency_exchange .round_prices');
  
  if (!exchangeRatesElement) {
    console.error('Exchange rates element not found');
    return;
  }
  
  let exchangeRates = {};
  try {
    exchangeRates = JSON.parse(exchangeRatesElement.textContent.trim());
  } catch (e) {
    console.error('Failed to parse exchange rates JSON:', e);
    return;
  }
  
  const shouldRoundPrices = roundPricesElement && roundPricesElement.textContent.trim().toLowerCase() === 'true';
  
  // Keep track of original prices
  const originalPrices = new Map();
  
  // Function to convert price based on currency code
  function convertPrice(priceInUSD, currencyCode) {
    // Don't convert if the currency is USD or if the currency is not in exchange rates
    if (currencyCode === 'USD' || !exchangeRates[currencyCode]) {
      return null; // Return null to indicate no conversion should happen
    }
    
    const exchangeRate = exchangeRates[currencyCode];
    let convertedPrice = priceInUSD * exchangeRate;
    
    if (shouldRoundPrices) {
      // Round down instead of to nearest integer
      convertedPrice = Math.floor(convertedPrice);
    }
    
    return convertedPrice;
  }
  
  // Function to format price with currency symbol
  function formatPrice(price, currencyCode) {
    // Basic currency symbol mapping (extend as needed)
    const currencySymbols = {
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'JPY': '¥',
      'CAD': 'C$',
      'AUD': 'A$',
      'NZD': 'NZ$',
      'CZK': 'Kč' // Added Czech Koruna
      // Add more currencies as needed
    };
    
    const symbol = currencySymbols[currencyCode] || currencyCode + ' ';
    
    // Special case for CZK - symbol comes after the number
    if (currencyCode === 'CZK') {
      if (shouldRoundPrices) {
        return price.toFixed(0) + ' ' + symbol;
      } else {
        return price.toFixed(2) + ' ' + symbol;
      }
    } else {
      if (shouldRoundPrices) {
        return symbol + price.toFixed(0);
      } else {
        return symbol + price.toFixed(2);
      }
    }
  }
  
  // Store currency with timestamp
  function storeCurrency(currency) {
    const currencyData = {
      currency: currency,
      timestamp: new Date().getTime()
    };
    localStorage.setItem('userCurrencyData', JSON.stringify(currencyData));
  }
  
  // Function to update all price elements
  function updatePrices(currencyCode) {
    // If currency is USD, no conversion needed
    if (currencyCode === 'USD' || !exchangeRates[currencyCode]) {
      console.log(`No conversion needed or available for ${currencyCode}`);
      return;
    }
    
    const moneyElements = document.querySelectorAll('.money');
    
    moneyElements.forEach(element => {
      // Get or store original price
      if (!originalPrices.has(element)) {
        const priceText = element.textContent.trim();
        const numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        originalPrices.set(element, numericPrice);
      }
      
      const originalPrice = originalPrices.get(element);
      const convertedPrice = convertPrice(originalPrice, currencyCode);
      
      // Only update if we got a valid conversion
      if (convertedPrice !== null) {
        element.textContent = formatPrice(convertedPrice, currencyCode);
        
        // Add data attributes for reference
        element.setAttribute('data-original-price', originalPrice);
        element.setAttribute('data-currency', currencyCode);
      }
    });
  }
  
  // Create a MutationObserver to watch for dynamic price changes
  const observer = new MutationObserver(function(mutations) {
    // If no valid exchange rate or currency is USD, don't observe
    if (userCurrency === 'USD' || !exchangeRates[userCurrency]) {
      return;
    }
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const moneyElements = document.querySelectorAll('.money');
        moneyElements.forEach(element => {
          if (!originalPrices.has(element) || element.getAttribute('data-currency') !== userCurrency) {
            // This is either a new element or one that hasn't been converted yet
            const priceText = element.textContent.trim();
            // Only process if it looks like a price
            if (/\$\d+(\.\d+)?/.test(priceText)) {
              const numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
              originalPrices.set(element, numericPrice);
              const convertedPrice = convertPrice(numericPrice, userCurrency);
              
              // Only update if we got a valid conversion
              if (convertedPrice !== null) {
                element.textContent = formatPrice(convertedPrice, userCurrency);
                element.setAttribute('data-original-price', numericPrice);
                element.setAttribute('data-currency', userCurrency);
              }
            }
          }
        });
      }
    });
  });
  
  // Configure the observer to watch for additions of nodes or changes to text content
  const observerConfig = { 
    childList: true, 
    subtree: true, 
    characterData: true 
  };
  
  // Get user's country and corresponding currency
  let userCurrency = 'USD'; // Default fallback
  
  function mapCountryToCurrency(countryName) {
    // Map of countries to currency codes (extend as needed)
    const countryCurrencyMap = {
      'United States': 'USD',
      'United Kingdom': 'GBP',
      'Canada': 'CAD',
      'Australia': 'AUD',
      'Japan': 'JPY',
      'Germany': 'EUR',
      'France': 'EUR',
      'Italy': 'EUR',
      'Spain': 'EUR',
      'New Zealand': 'NZD',
      'Ireland': 'EUR',
      'Czech Republic': 'CZK', // Added Czech Republic
      'Czechia': 'CZK' // Alternative name for Czech Republic
      // Add more mappings as needed
    };
    
    return countryCurrencyMap[countryName] || 'USD';
  }
  
  // Try to get currency from our pre-checked value (URL or localStorage)
  if (window.selectedCurrency && exchangeRates[window.selectedCurrency]) {
    // Use the previously determined currency
    userCurrency = window.selectedCurrency;
    console.log(`Using currency: ${userCurrency}`);
    
    // Start observing the document
    observer.observe(document.body, observerConfig);
    
    // Update prices immediately
    updatePrices(userCurrency);
  } else {
    // If no valid stored currency, fall back to country detection
    fetch('/browsing_context_suggestions.json')
      .then(res => res.json())
      .then(data => {
        if (data.detected_values && data.detected_values.country && data.detected_values.country.name) {
          const countryName = data.detected_values.country.name;
          userCurrency = mapCountryToCurrency(countryName);
          
          // Store this currency for future page visits (with timestamp)
          if (userCurrency !== 'USD') {
            storeCurrency(userCurrency);
          }
          
          // Only proceed if we have an exchange rate for this currency and it's not USD
          if (userCurrency !== 'USD' && exchangeRates[userCurrency]) {
            console.log(`Converting prices to ${userCurrency} based on country detection`);
            // Start observing the document
            observer.observe(document.body, observerConfig);
            
            // Update prices initially
            updatePrices(userCurrency);
          } else {
            console.log(`No conversion needed or available for ${userCurrency}`);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching country information:', error);
      });
  }
  
  // Add a currency selector for testing (optional)
  // Can be uncommented for development/testing purposes
  /*
  const currencySelector = document.createElement('div');
  currencySelector.style.position = 'fixed';
  currencySelector.style.bottom = '10px';
  currencySelector.style.right = '10px';
  currencySelector.style.zIndex = '9999';
  currencySelector.style.background = '#fff';
  currencySelector.style.padding = '5px';
  currencySelector.style.border = '1px solid #ccc';
  
  const selectEl = document.createElement('select');
  Object.keys(exchangeRates).forEach(code => {
    const option = document.createElement('option');
    option.value = code;
    option.textContent = code;
    if (code === userCurrency) {
      option.selected = true;
    }
    selectEl.appendChild(option);
  });
  
  selectEl.addEventListener('change', function() {
    const newCurrency = this.value;
    // Store currency with timestamp when changed
    storeCurrency(newCurrency);
    window.location.reload();
  });
  
  currencySelector.appendChild(selectEl);
  document.body.appendChild(currencySelector);
  */
});